exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".toast--_8Mbe {\n  background-color: #333333;\n  padding: 20px;\n  margin-bottom: 0;\n  align-items: center;\n  border: none;\n  border-radius: 0;\n  display: flex;\n  justify-content: center;\n  position: fixed;\n  left: 50%;\n  max-width: 100%;\n  opacity: 0.95;\n  transition: transform 400ms cubic-bezier(0.23, 1, 0.32, 1), visibility 400ms cubic-bezier(0.23, 1, 0.32, 1);\n  width: 500px;\n  z-index: 9999;\n  bottom: 0;\n}\n\n.toast--_8Mbe span {\n  color: #fff;\n  text-align: center;\n}\n\n.toast--_8Mbe.error--3YDG- {\n  background-color: #ff6633;\n}\n\n", ""]);

// exports
exports.locals = {
	"toast": "toast--_8Mbe",
	"error": "error--3YDG-"
};